// extracted by mini-css-extract-plugin
module.exports = {"label":"DeleteItemDialog_label__3_zOW","btnLink":"DeleteItemDialog_btnLink__2pUuD"};